export default __webpack_public_path__ + "static/media/practice_left_bg.18a6c8ce.png";